import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper'
import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, LabelList } from 'recharts'

export const TopRevenueClients = ({ data }) => {
    const clients = [
        { name: 'Acme', revenue: 92, color: '#4ac282' },
        { name: 'Globex', revenue: 74, color: '#53d080' },
        { name: 'Nova', revenue: 58, color: '#ecf7f0' },
        { name: 'Nova', revenue: 58, color: '#ecf7f0' },
    ]

    return (
        <DashboardCardWrapper
            headerText={'Top Revenue Clients'}
            headerSubtext={"Accounts driving the source"}
            componentClassname={"h-100"}
            componentStyles={{ position: "relative", overflow: "hidden" }}
        >
            <div style={{ width: '100%', height: '86%', position: 'absolute', bottom: 0, left: '5px', padding: "1rem" }}>
                <ResponsiveContainer width='100%' height='100%'>
                    <BarChart data={clients} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                        <XAxis
                            dataKey='name'
                            axisLine={false}
                            tickLine={false}
                            fontSize={12}
                            fontWeight={600}
                        />
                        <YAxis hide domain={[0, 100]} />

                        <Bar
                            dataKey='revenue'
                            radius={[12, 12, 12, 12]}
                            barSize={150}
                            background={{ fill: '#f8f9fa', radius: 10 }}
                        >
                            <LabelList
                                dataKey='revenue'
                                content={(props) => {
                                    const { x, y, width, height, value, index } = props;
                                    return (
                                        <>
                                            <line
                                                x1={x + width / 2 - 6}
                                                x2={x + width / 2 + 6}
                                                y1={y + height / 2 - 16}
                                                y2={y + height / 2 - 16}
                                                stroke='#000'
                                                strokeWidth={2}
                                                strokeLinecap='round'
                                            />

                                            <text
                                                x={x + width / 2}
                                                y={y + height / 2 + 4}
                                                textAnchor='middle'
                                                dominantBaseline='middle'
                                                fill={index === 0 ? '#fff' : '#000'}
                                                fontSize={14}
                                                fontWeight={700}
                                            >
                                                {`$${value}K`}
                                            </text>
                                        </>
                                    )
                                }}
                            />
                            {clients.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </DashboardCardWrapper>
    )
}
